import React from 'react'
import PeopleCard from '../PeopleProfileCard';
import img1 from '../../../Images/Sunandini.png'
import img2 from '../../../Images/Ganesh.jpeg'
import img3 from '../../../Images/Satyaveer.jpeg'
import img4 from '../../../Images/Shirshendu.jpeg'
import img5 from '../../../Images/Namrata.jpeg'

const createElements = () => {
  const elements = [];
  const PeopleImagesUrl = [img1,img2,img3,img4,img5];
  const PeopleName = ['Sunandini Swain','Karnati Ganesh Reddy','Satyaveer Singh','Shirshendu Bardhan','Namrata Singh'];
  const PeopleEmailId = ['Sunandini_2121cb10@iitp.ac.in','karnati_2221cb11@iitp.ac.in','satyaveer_2521cb13@iitp.ac.in','shirshendu_2521cb01@iitp.ac.in','namrata_2522cb05@iitp.ac.in'];
  const PeopleDescription = [
  `M.Tech. - Biotechnology, 2017
   B.Tech. - Biomedical Engineering, 2015
   PhD - IIT Patna, 2021 - 2026
   RESEARCH TOPIC - Computer aided based drug designing for Alzheimer's disease.`,

  `M.Tech. - Industrial Biotechnology, 2022
   B.Tech. - Biotechnology, 2020
   PhD - IIT Patna, AUG 2022 - Present, PMRF 
   RESEARCH TOPIC - Exploring Computational Advancements in Molecular Dynamics: From Protein Folding Pathways to Drug Optimization.`,
   
  `BTech - Biotechnology, 2025
   PhD - IIT Patna, AUG 2025 - Present 
   RESEARCH TOPIC - Molecular Exploration of Lipid–Protein Interactions`,
  
  `BSc - Chemistry (Hons), 2006
   B.Tech. - Chemical Engineering, 2009
   PhD - IIT Patna, AUG 2025 - Present (Part-time) 
   RESEARCH TOPIC - DAC and Gas hydrate`,
  
  `BSc - Zoology, 2023
   MSc - Zoology, 2023
   PhD - IIT Patna, JAN 2026 - Present 
   RESEARCH TOPIC - Molecular Exploration of Affinity Peptide Ligand for Antibody Purification`];

   const Link = [
    " ",
    " ",
  ];

  for (var i=0;i<PeopleName.length;i++){
      elements.push(<PeopleCard key = {i} peopleImagesUrl = {PeopleImagesUrl[i]} peopleName = {PeopleName[i]} peopleEmailId = {PeopleEmailId[i]} peopleDescription = {PeopleDescription[i]} link={Link[i]}/>)
  }
  return elements
}


const PhdScholar = () => {
  return (
    <div className="album py-2">
      <div className="row">
      {createElements()}
    </div>
  </div>
  )
}

export default PhdScholar